import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../../../../../shared/presentations/PageNotFound";
import UserCategoriesPage from "./pages/UserCategoriesPage";

export const UserCategoriesRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/"} exact={true}><UserCategoriesPage /></Route>
      <Route ><PageNotFound /></Route>
    </Switch>
  );
};
